import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomAnimatedButton from '../common/CustomAnimatedButton'
import bgCurves from '../../assets/images/bg-curves.png'
import Contact_hero from '../../assets/images/contact_hero.jpg'

const HeroSection4 = () => {
    return (
        <section className="hero-common hero-section">
            <div className="hero-bg-image pt-5 pt-md-4">
                <img src={bgCurves} alt="" width="100%" />
            </div>
            <Container className="hero-section px-0 pb-4 pb-md-5 pb-md-0">
                <Row className="m-0 p-0">
                    <Col
                        sm={12}
                        md={6}
                        className="hero-left px-4 px-md-0 d-flex my-auto ps-md-2 pe-md-2"
                    >
                        <section className="hero-content align-self-center pt-4 pb-4 ps-md-1">
                            <h6 className="breadcrumbs">Home / Contact Us</h6>
                            <h1 className="text-white hero-title py-2 py-md-1">
                                Ready to get your <span>project</span> off the
                                ground?
                            </h1>
                            <div className="hero-text pt-1">
                                <p className="px-2 pt-2 pb-1 py-md-2">
                                    Just like reamers, our services come in a
                                    variety of shapes and sizes. Contact us to
                                    learn more.
                                </p>
                            </div>
                            <div className="hero-actions d-inline-flex">
                                <CustomAnimatedButton
                                    link={'/contact-us#get-in-touch'}
                                    text={'Learn More'}
                                />
                            </div>
                        </section>
                    </Col>
                    <Col
                        sm={12}
                        md={6}
                        className="hero-right px-4 px-md-2 ps-md-5 h-100"
                    >
                        <div className="mb-3 ms-2 pe-1">
                            <div className="v-line float-start" />
                            <div className="media-wrapper">
                                <img
                                    src={Contact_hero}
                                    width="100%"
                                    height="100%"
                                    alt=""
                                />
                            </div>
                            <div className="h-line"></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default HeroSection4
